import { Effect, pipe } from 'effect';

// Constants
import { END_POINTS } from '@/constants/endpoint';
import { MESSAGES, STATUS_CODE } from '@shared/constants';

// Types
import { ActionItemType, Resume, Project } from '@shared/types';
import { HttpMethod } from '@/types/api';
import { RequestConfig } from '@/types/request';

// Services
import { httpClient } from '@/services/http';

export const getActionItems = (
  searchQuery: string,
  requestConfig: RequestConfig,
) =>
  Effect.runPromise(
    pipe(
      Effect.tryPromise({
        try: () =>
          httpClient<ActionItemType[]>(
            END_POINTS.SEARCH_FORM_MODAL(searchQuery),
            requestConfig,
          ),
        catch: (error) => ({
          data: null,
          error:
            error instanceof Error ? error.message : MESSAGES.GENERAL_ERROR,
          status: STATUS_CODE.INTERNAL_SERVER_ERROR,
        }),
      }),
      Effect.catchAll((error) => Effect.succeed(error)),
    ),
  );

export const executeActionItem = (
  itemAction: ActionItemType,
  requestConfig?: RequestConfig,
) => {
  const { identity, type, group, name } = itemAction;

  const minimalPayload = {
    identity: identity?.toLowerCase(),
    type,
    group,
    ...(name ? { data: { name } } : {}),
  };

  return Effect.runPromise(
    pipe(
      Effect.tryPromise({
        try: () =>
          httpClient<Project['projectInfo']>(END_POINTS.SEARCH_HANDLE_ACTION, {
            ...requestConfig,
            method: HttpMethod.POST,
            body: minimalPayload,
          }),
        catch: (error) => ({
          data: null,
          error:
            error instanceof Error ? error.message : MESSAGES.GENERAL_ERROR,
          status: STATUS_CODE.INTERNAL_SERVER_ERROR,
        }),
      }),
      Effect.catchAll((error) => Effect.succeed(error)),
    ),
  );
};

export const getResumeById = (
  resumeId: string,
  requestConfig?: RequestConfig,
) =>
  Effect.runPromise(
    pipe(
      Effect.tryPromise({
        try: () =>
          httpClient<Resume>(END_POINTS.GET_USER_RESUME_BY_ID(resumeId), {
            ...requestConfig,
            method: HttpMethod.GET,
            retry: { attempts: 2 },
          }),
        catch: (error) => ({
          data: null,
          error:
            error instanceof Error ? error.message : MESSAGES.GENERAL_ERROR,
          status: STATUS_CODE.INTERNAL_SERVER_ERROR,
        }),
      }),
      Effect.catchAll((error) => Effect.succeed(error)),
    ),
  );
